import { render } from "./get-quoting.vue?vue&type=template&id=c3741cc6&scoped=true"
import script from "./get-quoting.vue?vue&type=script&lang=js"
export * from "./get-quoting.vue?vue&type=script&lang=js"

import "./get-quoting.vue?vue&type=style&index=0&id=c3741cc6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3741cc6"]])

export default __exports__